import qs from 'qs';
import request from '../utils/request';

// 添加格子
export const createCabinet = (data) => request({
  url: '/admin/cabinet',
  method: 'post',
  data,
});
// 格子列表
export const cabinetList = (param) => request(`/admin/cabinet?${qs.stringify(param)}`);
// 疑似空箱
export const emptyBbox = (param) => request(`/admin/cabinet/empty-box?${qs.stringify(param)}`);
// 开箱
export const openbox = (id) => request({
  url: `/admin/cabinet/open-box/${id}`,
  method: 'put',
});
// 修改
export const modify = (id, data) => request({
  url: `/admin/cabinet/${id}`,
  data,
  method: 'put',
});
// 开箱日志
export const cabinetlog = (param) => request(`/admin/cabinetlog?${qs.stringify(param)}`);
// 获取批量添加信息
export const batchaddconfig = (id) => request(`/admin/cabinet/batch-add-config/${id}`);
// 获取分组
export const cabinetgroup = (keyWord) => request(`/admin/cabinet-group?keyWord=${keyWord}`);
// 叶子数据
export const cabineTreeData = (param) => request(`/admin/cabine-tree-data?${qs.stringify(param)}`);
// 刷新锁状态
export const refreshLockStatu = (param) => request(`/admin/cabinet/refresh-lock-statu?${qs.stringify(param)}`);
// 批量开箱
export const openAllBox = (param) => request(`/admin/station/cabinet/cabinet-open-all?${qs.stringify(param)}`);
